<template>
  <div>
    <div class="apply-cash" v-if="applyCash">
      <div class="common-header">
        <es-breadcrumb>
          <es-breadcrumb-item :to="{ path: '/MyWallet' }">{{ $t('我的账户') }}</es-breadcrumb-item>
          <es-breadcrumb-item>{{ $t('提现申请') }}</es-breadcrumb-item>
        </es-breadcrumb>
      </div>

      <div class="apply-container common-body">
        <span style="font-size: 20px; font-weight: bold">{{ this.$route.query.companyName }}</span>
        <div class="input-cash" :style="{ height: isRightAmount ? '77px' : '105px' }">
          <es-form :model="inputCash" label-width="135px" :rules="inputCashRule" ref="inputCashForm" @submit.native.prevent>
            <es-row>
              <es-col :span="6">
                <es-form-item :label="$t(`可提现余额`)">
                  <div class="cash" style="color: #0975e1">
                    <span class="color-666 weight-400"></span> {{ this.$route.query.balance }}
                    <span class="color-666 weight-400">{{ $t('元') }}</span>
                  </div>
                </es-form-item>
              </es-col>
              <es-col :span="6">
                <es-form-item :label="$t(`提现中`)">
                  <div class="cash" style="color: #0975e1">
                    <span class="color-666 weight-400"></span> {{ this.$route.query.freezeBalance }}
                    <span class="color-666 weight-400">{{ $t('元') }}</span>
                  </div>
                </es-form-item>
              </es-col>
              <es-col :span="6">
                <es-form-item prop="amount" :label="$t(`提现金额`)">
                  <div class="input-cash-in">
                    <es-tooltip
                      class="item"
                      effect="dark"
                      :content="$t(`为保障您所在的主体账户资金安全，一天内一个主体仅能操作提现1次，请谨慎操作！`)"
                      placement="bottom-start"
                    >
                      <i class="el-icon-warning-outline" style="margin-right: 10px"></i>
                    </es-tooltip>
                    <es-input
                      v-model="inputCash.amount"
                      :placeholder="$t(`请输入大于1.00元的数字`)"
                      class="input-number"
                      style="width: 220px"
                    >
                      <template slot="append">{{ $t('元') }}</template>
                    </es-input>
                  </div>
                </es-form-item>
              </es-col>
            </es-row>
          </es-form>
        </div>
        <p class="to-bank">
          <span class="size-14">{{ $t('提现至银行账户') }}</span>
          <es-tooltip
            class="item"
            effect="dark"
            :content="$t(`请保证银行账户信息准确且未失效，否则将无法打款成功！`)"
            placement="bottom-start"
          >
            <i class="el-icon-warning-outline" style="margin-left: 5px"></i>
          </es-tooltip>
        </p>
        <div class="first-apply-cash" v-if="show">
          <es-form :model="editBankInfo" label-width="162px" :rules="rules" ref="ruleForm" @submit.native.prevent class="custom-form">
            <es-form-item :label="$t(`开户行全称`)" prop="fullNameOfBank">
              <es-select
                v-model="editBankInfo.fullNameOfBank"
                filterable
                clearable
                remote
                :placeholder="$t(`请输入开户行关键词`)"
                :remote-method="remoteMethod"
                :loading="searchLoading"
                class="width-410"
              >
                <es-option v-for="item in bankList" :key="item.id" :label="item.subBankName" :value="item.id"></es-option>
              </es-select>
            </es-form-item>
            <es-form-item :label="$t(`提现银行`)">
              <span class="color-999 size-12">{{ editBankInfo.bank }}</span>
            </es-form-item>
            <es-form-item :label="$t(`银行账户名`)">
              <span class="color-999 size-12">{{ userInfo.name }}</span>
            </es-form-item>
            <es-form-item :label="$t(`银行账号`)" prop="cardNo">
              <es-input v-model.trim="editBankInfo.cardNo" class="width-410" maxlength="60"></es-input>
            </es-form-item>
          </es-form>
        </div>
        <div class="bank-history" v-else>
          <div class="item size-14">{{ editBankInfo.subBankName }}</div>
          <div class="item size-14">{{ editBankInfo.cardNo }}</div>
          <div class="item size-14">{{ editBankInfo.accountName }}</div>
          <es-button type="text" @click="handleEditBankInfo">{{ $t('修改银行卡') }}</es-button>
        </div>
        <div class="footer" :style="{ marginTop: show ? '60px' : '100px' }">
          <es-button type="primary" @click="handleSubmit" :disabled="disabled" :loading="submitLoading">{{ $t('确认提现') }}</es-button>
        </div>
      </div>
      <!-- 提现验证 -->

      <es-dialog
        :visible.sync="dialogVisible"
        width="520px"
        :before-close="handleClose"
        top="30vh"
        custom-class="confirm-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div slot="title">
          <span class="size-16 weight-500 color-333">{{ $t('提现验证') }}</span>
        </div>
        <div class="dialog-main">
          <div class="type-pwd">
            <div class="type-item margin-bottom-15 size-14px color-333" v-if="usePwd">{{ $t('为保障您的账户安全，请输入签署密码：') }}</div>
            <div class="type-item margin-bottom-15 size-14px color-333" v-if="useMsgCode">
              {{ $t('管理员手机号：') }}<span class="color-999">{{ mobileNum }}</span>
            </div>
            <es-form
              :model="inputPwdOrCode"
              :rules="inputPwdFormRule"
              ref="inputPwdForm"
              :disabled="submitDisabled"
              @submit.native.prevent
              :label-width="useMsgCode ? '68px' : '0'"
              v-if="dialogVisible"
            >
              <es-form-item :prop="'value'" :label="useMsgCode ? $t('验证码：') : ''">
                <div class="type-item" v-if="usePwd">
                  <es-input
                    v-model.trim="inputPwdOrCode.value"
                    type="password"
                    class="width-308"
                    :placeholder="$t(`请输入签署密码`)"
                    @keyup.enter.native="handleSubmitApplyCash"
                  ></es-input>
                </div>
                <div class="type-item flex" v-if="useMsgCode">
                  <es-input
                    v-model.trim="inputPwdOrCode.value"
                    type="pasword"
                    class="width-180"
                    :placeholder="$t(`请输入6位验证码`)"
                    @keyup.enter.native="handleSubmitApplyCash"
                  ></es-input>
                  <es-button type="primary" @click="sendMsg" :disabled="isRecieving" class="send-msg-btn margin-0 margin-left-20">
                    {{
                      isRecieving
                        ? $t('{time} 秒后获取', {
                            time: time,
                          })
                        : $t('发送验证码')
                    }}
                  </es-button>
                </div>
              </es-form-item>
            </es-form>

            <div class="type-item" :style="{ marginTop: isRightCode ? '-8px' : '28px' }">
              <es-button type="text" @click="changeType('MOBILE')" v-if="usePwd && mobileNum">{{ $t('使用动态验证码') }}</es-button>
              <es-button type="text" @click="changeType('INFO_PWD_SIGN')" v-if="useMsgCode">{{ $t('使用签署密码') }}</es-button>
            </div>
            <div class="type-item" v-if="usePwd">
              {{ $t('还没有签署密码？') }}<es-button type="text" @click="setSignPwd()">{{ $t('去设置') }}</es-button>
            </div>
          </div>
          <div class="type-pwd">
            <div class="type-item"></div>
          </div>
        </div>
        <span slot="footer">
          <es-button variant="outline" @click="handleClose">{{ $t('取消') }}</es-button>
          <es-button type="primary" @click="handleSubmitApplyCash" :disabled="submitDisabled">{{ $t('确定') }}</es-button>
        </span>
      </es-dialog>
    </div>
    <Result :success="applyResult" v-if="showResult" :amount="inputCash.amount" />
  </div>
</template>
<script>
import { $t } from '@/locales'

import Result from './applyCashResult.vue'
import '@/assets/css/common.css'
import divided from '../../components/divided'

import { mapState } from 'vuex'
const setTime = 60
export default {
  components: {
    Result,
    divided,
  },
  data() {
    const validAmount = (rule, value, callback) => {
      this.isRightAmount = false
      const reg = /^\d+(\.\d{1,2})?$/
      if (!value) {
        return callback(new Error($t('请输入提现金额')))
      } else if (!reg.test(value)) {
        return callback(new Error($t('请输入正确的提现金额，保留2位有效数字')))
      } else if (value < 1) {
        return callback(new Error($t('请输入正确的提现金额，保留2位有效数字')))
      } else if (value > this.walletAmount.balance || value > 300) {
        return callback(new Error($t('输入金额不能超过可提现余额(单次最多提现300元)')))
      }
      this.isRightAmount = true
      callback()
    }
    const validPwdAndMsgCode = (rule, value, callback) => {
      this.isRightCode = false
      const text = this.usePwd ? $t('签署密码') : $t('验证码')
      if (!value) {
        return callback(new Error($t('{text}不能为空', { text: text })))
      }
      if (this.useMsgCode && !/^[0-9]{6}$/.test(value)) {
        return callback(new Error($t('验证码格式不正确')))
      }
      this.isRightCode = true
      callback()
    }
    const validBankName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error($t('请输入开户行全称')))
      }
      callback()
    }
    const validBankNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error($t('请输入银行账号')))
      }
      const reg = /^[0-9]{8,}$/
      if (!reg.test(value)) {
        return callback(new Error($t('银行卡账号长度不能小于8位(数字)')))
      }
      callback()
    }

    return {
      isFirst: false,
      isEdittingBankInfo: false,
      editBankInfo: {
        bankName: '',
        fullNameOfBank: '',
        cardNo: '',
        subBankName: '',
      },
      bankInfo: {},
      rules: {
        fullNameOfBank: [
          {
            validator: validBankName,
            trigger: 'change',
          },
        ],

        cardNo: [
          {
            validator: validBankNo,
            trigger: '',
          },
        ],
      },
      dialogVisible: false,
      submitLoading: false,
      inputType: 'INFO_PWD_SIGN',
      time: setTime,
      timer: null,
      isRecieving: false,
      num: '',
      walletAmount: {
        balance: '',
      },
      mobileNum: '',
      inputCash: {
        amount: '',
      },
      inputCashRule: {
        amount: [
          {
            validator: validAmount,
            trigger: '',
          },
        ],
      },
      inputPwdOrCode: {
        value: '',
        code: '',
      },
      inputPwdFormRule: {
        value: [
          {
            validator: validPwdAndMsgCode,
            trigger: 'change',
          },
        ],

        code: [
          {
            validator: validPwdAndMsgCode,
            trigger: 'change',
          },
        ],
      },
      walletType: '',
      bankList: [],
      searchLoading: false,
      applyCash: true,
      applyResult: false,
      applicationId: '',
      submitDisabled: false,
      isRightAmount: true,
      isRightCode: true,
    }
  },
  watch: {
    'editBankInfo.fullNameOfBank'(val) {
      const result = this.bankList.find(item => item.id === val)
      if (result) {
        this.editBankInfo.bank = result.bankName
        this.editBankInfo.city = result.cityName
        this.editBankInfo.province = result.provinceName
        this.editBankInfo.subBankName = result.subBankName
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    show() {
      return this.isFirst || this.isEdittingBankInfo
    },
    disabled() {
      return this.walletAmount.balance < 1
    },
    usePwd() {
      return this.inputType === 'INFO_PWD_SIGN'
    },
    useMsgCode() {
      return this.inputType === 'MOBILE' && this.mobileNum
    },
    showResult() {
      return !this.applyCash
    },
  },
  // 初始化
  async created() {
    const walletType = this.$route.query.type
    if (walletType && ['DEFAULT', 'COOP_BONUS', 'GZ_JG_DEFAULT', 'BJ_JG_DEFAULT', 'JX_JG_DEFAULT'].includes(walletType)) {
      this.walletType = walletType
      this.walletAmount = await this.getMoneyOfWallet()
      this.getMyBankInfo(true)
    } else {
      return this.$message.error($t('参数错误'))
    }
  },
  methods: {
    // 确认提现点击事件
    async handleSubmit() {
      const self = this
      this.walletAmount = await this.getMoneyOfWallet()
      if (this.walletAmount.balance < 1) {
        this.$message.error($t('您的可提现金额小于 1 元，不可提现！'))

        return
      }
      self.$refs.inputCashForm.validate(validAmount => {
        if (!validAmount) return

        if (this.show) {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              this.$confirm($t('确认是否提现?'), $t('提示'), {
                confirmButtonText: $t('确定'),
                cancelButtonText: $t('取消'),
                type: 'warning',
              })
                .then(() => {
                  this.handleSubmitApplyCash()
                })
                .catch(() => {})
            }
          })
        } else {
          this.$confirm($t('确认是否提现?'), $t('提示'), {
            confirmButtonText: $t('确定'),
            cancelButtonText: $t('取消'),
            type: 'warning',
          })
            .then(() => {
              this.handleSubmitApplyCash()
            })
            .catch(() => {})
        }
        this.submitDisabled = false
      })
    },
    handleEditBankInfo() {
      this.getMyBankInfo(false)
    },
    changeType(type) {
      this.inputType = type
      this.isRightCode = true
      this.$refs.inputPwdForm.resetFields()
    },
    handleClose() {
      this.$refs.inputPwdForm.clearValidate()
      this.dialogVisible = false
      this.isRightCode = true
      this.inputPwdOrCode = {
        value: '',
      }
    },
    setSignPwd() {
      window.open(this.$Dic.getDefaultURL().setPwdUrl)
    },
    getIsTodayApply() {
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getIsTodayApply(), {})
          .then(res => {
            resolve(res.data.ifSuccess)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async sendMsg() {
      if (this.isRecieving) return
      if (await this.getMsgCode()) {
        this.$message.success($t('验证码已发送!'))
        this.isRecieving = true
        this.setSecond(this.time, time => {
          this.isRecieving = time > 0
          this.time = time > 0 ? time : setTime
        })
      } else {
        return this.$message.error($t('发送验证码失败!'))
      }
    },
    setSecond(time, cb) {
      let timer
      timer = setInterval(() => {
        if (time > 0) {
          time--
        } else {
          window.clearInterval(timer)
        }
        cb(time)
      }, 1000)
    },
    handleSubmitApplyCash() {
      const self = this
      self.submitDisabled = true
      const { cardNo, bank, subBankName, city, province } = self.editBankInfo
      const params = {
        bank,
        fullNameOfBank: subBankName,
        cardNo,
        city,
        province,
      }
      params.amount = self.inputCash.amount
      params.walletType = self.walletType
      if (self.applicationId && !this.show) {
        params.applicationId = self.applicationId
      }
      this.submitLoading = true
      // 提现申请
      this.$ajax(this.$url.doApplyCash(), params)
        .then(res => {
          this.submitLoading = false
          if (res.code == 0) {
            self.applyCash = false
            self.applyResult = true
          } else {
            this.dialogVisible = false
          }
        })
        .catch(() => {
          this.submitLoading = false
          self.submitDisabled = false
        })
    },
    // 获取手机号验证码
    getMsgCode() {
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getMsgCode(), {})
          .then(res => {
            if (res.code == 0) {
              resolve(res.data.authCodeId || false)
            } else {
              reject(res)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    // 获取可提现金额和提现中金额
    getMoneyOfWallet() {
      return new Promise((resolve, reject) => {
        this.$ajax(this.$url.getMoneyOfWallet(), {
          walletType: this.walletType,
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async allAmountToApply() {
      const amoutResult = await this.getMoneyOfWallet()
      this.walletAmount = amoutResult
      this.inputCash.amount = amoutResult.balance
    },
    // 获取当前用户管理员绑定的手机号
    getBindPhone() {
      this.$ajax(this.$url.getBindPhone(), {}).then(res => {
        this.mobileNum = res.data.mobileNum
      })
    },
    // 根据支行名称获取银行信息
    getBankInfoBySubName(subBankName) {
      const self = this
      this.$ajax(this.$url.getBankInfoBySubName(), {
        subBankName,
      })
        .then(res => {
          self.bankList = res.data.list
          self.searchLoading = false
        })
        .catch(err => (self.searchLoading = false))
    },
    remoteMethod(query) {
      if (query && query.trim()) {
        this.searchLoading = true
        this.getBankInfoBySubName(query.trim())
      }
    },
    // 获取最后一次提现
    getMyBankInfo(needEncryption) {
      this.$ajax(this.$url.getMyBankInfo(needEncryption), {})
        .then(res => {
          if (res.data) {
            this.editBankInfo = res.data
            this.editBankInfo.subBankName = res.data.fullNameOfBank
            this.applicationId = res.data.applicationId || null
            if (needEncryption) {
              this.isFirst = false
            } else {
              this.isEdittingBankInfo = true
              this.applicationId = ''
            }
          } else {
            this.isFirst = true
          }
        })
        .catch(() => (this.isFirst = true))
    },
  },
}
</script>
<style lang="less" scoped>
.input-cash {
  padding-top: 23px;
  height: 77px;
  transition: height 0.3s;

  .input-cash-in {
    line-height: 30px;

    .input-number {
      margin-right: 6px;
      width: 197px;
    }

    .yuan {
      display: block;
    }
  }
}

.apply-container {
  .apply-header {
    display: flex;
    padding: 16px 0;
  }

  .cash {
    margin-right: 52px;
  }

  .to-bank {
    margin: 15px 0 14px;
    display: flex;
    align-items: flex-end;
    color: #333;
  }

  .width-input {
    width: 300px;
  }

  .footer {
    margin-top: 200px;
    display: flex;
    justify-content: right;
  }

  .first-apply-cash {
    background: rgba(248, 248, 248, 1);
    border: 1px solid #e4e4e4;
    padding: 40px 0 52px 16px;
  }

  .bank-history {
    background: rgba(248, 248, 248, 1);
    border: 1px solid #e4e4e4;
    padding: 14px 70px 14px 15px;
    display: flex;
    justify-content: space-between;

    .item {
      height: 20px;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
    }
  }
}

.dialog-main {
  .flex {
    display: flex;
    justify-content: flex-start;

    .width-110 {
      width: 110px;
    }
  }
}

.send-msg-btn {
  padding: 7px 13px;
  width: fit-content;
  line-height: 16px;
}

.width-410 {
  width: 410px;
}
</style>
